import { Box, Button, TextField, Typography } from '@mui/material';
import React, { FormEventHandler, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { NavLink as RouterLink } from 'react-router-dom';

import { CrisCategoryPicker } from 'app/components/cris-category-picker';
import { Brand } from 'app/model/cris/brand';
import { brandService } from 'app/services/brand.service';
import { ModelWithoutId } from 'app/type';
import { InputValueUtils } from 'app/utils/input-value-utils';
import { setCurrentBrand } from 'features/cris/cris.slice';

export const BrandForm: React.FunctionComponent = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    const dispatch = useDispatch();

    const [brand, setBrand] = useState<ModelWithoutId<Brand>>({ name: '' });

    const isNew = 'new' === id;

    const handleSubmit: FormEventHandler = (evt) => {
        evt.preventDefault();
        brandService.save(brand).subscribe((updatedBrand) => {
            dispatch(setCurrentBrand(updatedBrand));
            history.replace(`/cris/brands/${updatedBrand.id}/details`);
        });
    };

    const handleBrandChange = (evt: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        if (!evt.target.name) {
            throw new Error('Name was not provided');
        }

        let value = evt.target.value;
        if ('name' === evt.target.name) {
            value = (value as string).toUpperCase();
        }

        setBrand({ ...brand, [evt.target.name]: value });
    };

    useEffect(() => {
        if (!isNew) {
            brandService.get(id).subscribe(setBrand);
        }
    }, [id, isNew]);

    const cancelLink = isNew ? '' : `/${id}/details`;

    return (
        <form onSubmit={handleSubmit}>
            <Typography variant='h6'>
                {isNew ? 'Create' : 'Edit'} Brand{isNew ? '' : `: ${id}`}
            </Typography>
            <div>
                <TextField name='name' label='Name' value={brand.name} onChange={handleBrandChange} />
                <TextField
                    name='midCount'
                    label='MID Count'
                    value={InputValueUtils.optionalToString(brand.midCount)}
                    onChange={handleBrandChange}
                />
                <TextField
                    name='locationId'
                    label='Location ID'
                    value={InputValueUtils.optionalToString(brand.locationId)}
                    onChange={handleBrandChange}
                />
                <Box sx={{ width: '20em' }}>
                    <CrisCategoryPicker value={brand.category} name='category' onChange={handleBrandChange} />
                </Box>
            </div>
            <Button type='submit' variant='outlined' color='primary' className='mt-2'>
                Save
            </Button>
            <Button
                type='button'
                variant='outlined'
                color='inherit'
                className='mt-2 ml-1'
                component={RouterLink}
                to={`/cris/brands${cancelLink}`}
            >
                Cancel
            </Button>
        </form>
    );
};
